module.exports = global["Modernizr"] = require("-!/Users/manu/Workspace/qatar-funding.eu/node_modules/modernizr-loader/index.js!/Users/manu/Workspace/qatar-funding.eu/node_modules/json-loader/index.js!./modernizrrc.json");


//////////////////
// WEBPACK FOOTER
// ../config/modernizrrc.json-exposed
// module id = 446
// module chunks = 1